import * as constants from './constants';

export const getUser = () => ({ type: constants.GET_USER });
export const getUserSuccess = (payload) => ({ type: constants.GET_USER_SUCCESS, payload });
export const getUserError = (payload) => ({ type: constants.GET_USER_ERROR, payload });

export const updateUser = (payload) => ({ type: constants.UPDATE_USER, payload });
export const updateUserSuccess = (payload) => ({ type: constants.UPDATE_USER_SUCCESS, payload });
export const updateUserError = (payload) => ({ type: constants.UPDATE_USER_ERROR, payload });

export const login = (payload) => ({ type: constants.LOGIN, payload });
export const loginSuccess = () => ({ type: constants.LOGIN_SUCCESS });
export const loginError = (payload) => ({ type: constants.LOGIN_ERROR, payload });
